import { forwardRef, useRef } from 'react'
import CreatableSelect from 'react-select/creatable'

export default forwardRef(function SelectCreatable(
    {
        id = '',
        label = '',
        placeholder = '',
        className = '',
        error = '',
        message = '',
        ...props
    },
    ref,
) {
    const input = useRef()

    return (
        <div className={className}>
            {label && (
                <label
                    htmlFor={id}
                    className={`block mb-1 font-medium ${error ? 'text-danger' : 'text-black dark:text-white'}`}
                >
                    {label}
                </label>
            )}
            <div className={`relative bg-white dark:bg-strokedark text-body`}>
                <CreatableSelect
                    {...props}
                    id={id}
                    placeholder={label ? label : placeholder}
                    ref={ref ?? input}
                    styles={{
                        input: (base) => ({
                            ...base,
                            'input:focus': {
                                boxShadow: 'none',
                            },
                        }),
                    }}
                />
            </div>
            {error && <p className="text-sm text-danger">{message}</p>}
        </div>
    )
})
